import {UserService} from '@digital-supply-chain/module'
import Message from "./message";
import axios from "axios";

axios.interceptors.request.use(function (config) {
	// 在发送请求之前做些什么
	let token = UserService.token(true);
	// @ts-ignore
	config.headers.Authorization = token;
	// @ts-ignore
	config.headers.tokenType = "jrzz";
	return config;
});

async function origin_ajax(_type: string, _url: string, _params: any = {}, _options: any = {}) {
	try {
		// @ts-ignore
		return await axios[_type](_url, _params, _options);
	} catch (response) {
		// @ts-ignore
		Message.error(response.data?.Message || response.data || response.title || response.message);
		throw {
			// @ts-ignore
			Message: response.data?.Message || response.data || response.message,
			// @ts-ignore
			Code: response.status,
		};
	}
}

async function ajax(_type: string, _url: string, _params: any = {}, _options: any = {}) {
	let noShowErr = _params.noShowErr || _options.noShowErr;
	let result: any = await origin_ajax(_type, _url, _params, _options);

	const offErrorMsg = _options.offErrorMsg || _params.offErrorMsg;
	let res = result.data;

	if (_params.interceResponse || _options.interceResponse) {
		return res || result;
	}

	if (res.State == 1) {
		return res.Data;
	} else if (res.hasOwnProperty("code")) {
		if (res.code !== 0 && !noShowErr) {
			let error = res.massage || res.error;
			Message.error(error, 5000);
			throw error;
		}
		return res;
	} else if (res.hasOwnProperty("err")) {
		if (res.err !== 0 && !noShowErr) {
			let error = res.msg;
			Message.error(error, 5000);
			throw error;
		}
		return res;
	} else {
		const error = res.Error || res.error || res.massage || res;
		error && !offErrorMsg && Message.error(error.Message || error.massage || error, 5000);
		if (!offErrorMsg) {
			throw error;
		}
		return res.Data;
	}
}

export class DataService {
	static async get(_url: string, _params: any = {}, _options: any = {}) {
		return await ajax("get", _url, { params: _params, ..._options });
	}

	static async post(_url: string, _params: any = {}, _options: any = {}) {
		return await ajax("post", _url, _params, _options);
	}
}
